import styled from '@emotion/styled';
export const NoWrap = styled.div`
  white-space: nowrap;
  word-break: keep-all;
  word-wrap: normal;
  hyphens: none;
`;
